module.exports = {"home":"首頁","video":"視頻","role":"武將","map":"戰國地圖","summary":"遊戲介紹","company":{"text1":"本遊戲涉及部分暴力內容，依遊戲軟體分級管理辦法分類為輔12級。","text2":"本遊戲為免費使用，遊戲內另提供購買虛擬遊戲幣、物品等付費服務。請注意使用時間，避免沉迷。","text3":"Terms of Services","text4":"Privacy Policy","text5":"本遊戲由香港商阿爾發遊戲有限公司台灣分公司代理港台營運","text6":"","text7":""},"index":{"channel_text":"即刻下載！"},"new":{"all":"全部","tz":"通知","wh":"維護","hd":"活動","prev":"上一頁","next":"下一頁","news":"新聞列表","top":"返回頂部"},"phonetext":{"new":"新聞","fb":"FACEBOOK"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/zh_cn.json
// module id = g28Y
// module chunks = 1